const ServiceBox = ({ children }) => {
    return (
        <div className="flex flex-wrap gap-4 justify-between">
            {children}
        </div>
    );
};

export default ServiceBox;